import { useRef } from 'react';

export function useDoubleClickDetection(threshold = 200) {
    const lastClickTimeRef = useRef<number>(Date.now());

    const checkDoubleClick = (): boolean => {
        const now = Date.now();
        const isDoubleClick = (now - lastClickTimeRef.current) < threshold;
        lastClickTimeRef.current = now;
        return isDoubleClick;
    };

    return checkDoubleClick;
}
